/* eslint-disable import/prefer-default-export */
export function findNodeSiblingsWithIndex(nodesTree, nodeUuid) {
  const list = Array.isArray(nodesTree) ? nodesTree : [];
  const directIndex = list.findIndex((item) => item?.uuid === nodeUuid);

  if (directIndex > -1) {
    return {
      siblings: list,
      index: directIndex,
    };
  }

  let nestedResult = null;
  list.some((item) => {
    if (!Array.isArray(item?.items) || item?.items?.length === 0) {
      return false;
    }

    nestedResult = findNodeSiblingsWithIndex(item.items, nodeUuid);
    return !!nestedResult;
  });

  if (nestedResult) {
    return nestedResult;
  }

  return null;
}
